// @ts-nocheck
import PropTypes from 'prop-types';
import { Navigate, useSearchParams } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();

  if (isAuthenticated) {
    const redirect = searchParams.get('redirect');
    return <Navigate to={redirect || PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}